import { TDeviceType } from '@cian/ui-kit';
import * as React from 'react';

// deviceType, с которым OwnTemplates рендерит штатные adfox-шаблоны (выбор desktop/mob-картинок).
// Дефолт desktop; parallax-слот переопределяет на phone, т.к. узкая колонка с картой обрезает крупный креатив.
export const AdfoxDeviceTypeContext = React.createContext<TDeviceType>('desktop');
